import { render, staticRenderFns } from "./404.vue?vue&type=template&id=fc633cc4&scoped=true"
import script from "./404.vue?vue&type=script&lang=js"
export * from "./404.vue?vue&type=script&lang=js"
import style1 from "./404.vue?vue&type=style&index=1&id=fc633cc4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc633cc4",
  null
  
)

export default component.exports